import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route: the page itself lives in es.industrias.medical-devices.acceso-al-mercado-europeo.index.tsx. Without this wrapper the
// page component would shadow every nested child route.
export const Route = createFileRoute("/es/industrias/medical-devices/acceso-al-mercado-europeo")({
  component: RouteLayout,
});

function RouteLayout() {
  return <Outlet />;
}
